import { useEffect, useRef } from "react";
import styles from "./ProgressBar.module.css";

export const ProgressBar = ({
  progress,
  color,
}: {
  progress: () => number;
  color: string;
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref !== null) {
      ref.current!.style.width = `${progress()}%`;
    }
  }, [progress, color]);

  return (
    <div className={styles["progress-bar"]}>
      <div ref={ref} className={styles["progress-bar__progress"]}></div>
    </div>
  );
};
